const item = localStorage?.okkami_webstore_propertyData;
let brand = null;

if (item !== undefined && item.length !== 0) {
  const propertyData = JSON.parse(item);
  brand = propertyData?.brand?.name;
}

export const appConfig = {
  brand: brand || "Okkami Brand",
  webAppVersion: "0.1",
};
